import { Icon } from '@chakra-ui/react';

export const WalletIcon = () => {
	return (
		<Icon
			w="20px"
			h="14px"
			viewBox="0 0 20 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 7.00002V7.01001M3 13H17C18.1046 13 19 12.1046 19 11V3C19 1.89543 18.1046 1 17 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13ZM19 4H12C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10H19V4Z"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
